module.exports = __webpack_public_path__ + "static/media/34.7d939244.gif";